import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "flex h-16 items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 189.69 100.41",
  class: "h-8"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m117.28,81.43c8.7-4.18,15.17-8.8,19.4-13.87.69,1.01,1.46,1.95,2.31,2.83,4.37,4.5,9.91,6.74,16.61,6.74,8.34,0,14.43-2.86,18.27-8.58v6.87h15.82V14.12h-15.82v33.11c0,5.07-1.22,8.87-3.68,11.4-2.45,2.53-5.72,3.8-9.81,3.8-3.68,0-6.62-1.08-8.83-3.25-2.21-2.17-3.31-5.29-3.31-9.38V14.12h-15.82v4.37c-1.44-2.05-3.07-4-4.91-5.83C119.08,4.22,108.6,0,96.05,0c-6.21,0-11.91,1.03-17.09,3.1-6.47,2.58-12.36,6.46-17.6,11.02h-14.53l-14.31,39.3-3.8-9.78-6.14-15.82-5.31-13.69H0l24.91,59.96c-1.45,3.85-3.35,6.67-5.72,8.46-2.49,1.88-5.87,2.78-10.12,2.7v14.71c7.85.41,14.39-1.37,19.66-5.33,5.27-3.96,9.48-10.34,12.67-19.08l12.64-34.73c.77-10.72,4.74-19.7,11.89-26.94,4.91-4.97,10.58-8.43,17.01-10.35-8.91,1.39-8.87,1.38.01,0,.54-.16,1.08-.31,1.62-.45l-.42.03.42-.03c3.6-.92,7.43-1.38,11.49-1.38,12.08,0,22.17,4.06,30.29,12.18,7.94,7.94,12.01,19.8,12.01,30.91s-4.11,21.77-12.27,29.87c-2.73,2.72-5.67,4.98-8.81,6.79Zm-1.13-16.21c5.37-5.37,8.06-12.19,8.06-20.45s-2.69-15.08-8.06-20.45c-5.37-5.37-12.05-8.06-20.04-8.06s-14.63,2.69-19.93,8.06c-5.3,5.37-7.95,12.19-7.95,20.45s2.65,15.08,7.95,20.45c5.3,5.37,11.94,8.06,19.93,8.06s14.66-2.69,20.04-8.06Zm-13.6-29.06c-7.2,2.35-20.15-13.34-19.48,1.92.54,12.26,3.46,18.99,5.94,21.31,5.6,5.24,1.83-8.8,7.1-9.19,5.27.39,1.5,14.42,7.1,9.19,2.48-2.32,5.39-9.05,5.94-21.31.54-12.16-6.97-5.42-11.85-4.42,1.16,1.21,2.91,2.04,5.25,2.5Z",
    style: {"fill":"#fff","fill-rule":"evenodd","stroke-width":"0px"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m74.96,88.7h42.31v11.71h-42.31v-11.71Z",
    style: {"fill":"#fff","fill-rule":"evenodd","stroke-width":"0px"}
  })
], -1)
const _hoisted_5 = { class: "hidden md:block" }
const _hoisted_6 = { class: "ml-10 flex items-baseline space-x-4" }
const _hoisted_7 = ["onClick", "aria-current"]
const _hoisted_8 = { class: "flex flex-1 justify-center px-2 lg:ml-6 lg:justify-end" }
const _hoisted_9 = { class: "hidden md:block" }
const _hoisted_10 = { class: "ml-10 flex items-baseline space-x-4" }
const _hoisted_11 = {
  key: 0,
  class: "hidden md:block"
}
const _hoisted_12 = { class: "ml-4 flex items-center md:ml-6" }
const _hoisted_13 = {
  type: "button",
  class: "relative rounded-full bg-brand-primary-600 p-1 text-brand-primary-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-primary-600"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-1.5" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "View notifications", -1)
const _hoisted_16 = { class: "-mr-2 flex md:hidden" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-0.5" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_19 = { class: "space-y-1 px-2 pb-3 pt-2 sm:px-3" }
const _hoisted_20 = { class: "border-t border-brand-primary-700 pb-3 pt-4" }
const _hoisted_21 = {
  key: 0,
  class: "flex items-center px-5"
}
const _hoisted_22 = { class: "flex-shrink-0" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "ml-3" }
const _hoisted_25 = { class: "text-base font-medium text-white" }
const _hoisted_26 = { class: "text-sm font-medium text-brand-primary-300" }
const _hoisted_27 = {
  type: "button",
  class: "relative ml-auto flex-shrink-0 rounded-full bg-brand-primary-600 p-1 text-brand-primary-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-primary-600"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-1.5" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "View notifications", -1)
const _hoisted_30 = { class: "mt-3 space-y-1 px-2" }

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/vue/24/outline'
// import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid'
import UserMenuItem from '@/components/UserMenuItem.vue'
import { useAuth0 } from "@auth0/auth0-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuContainer',
  setup(__props) {

const { isAuthenticated } = useAuth0();
const route = useRoute();
const router = useRouter();

const handleNavigation = (path) => {
	router.push(path);
}

const navigation = computed(() => {
	const nav = []
	if (isAuthenticated.value) {
		nav.push({ name: 'Dashboard', href: '/dashboard', current: route.path === '/dashboard' })
	}
	nav.push({ name: 'Listings', href: '/listings', current: route.path === '/listings' })
	return nav
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(Disclosure), {
    as: "nav",
    class: "bg-brand-primary-500"
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "flex-shrink-0"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: item.name,
                    onClick: _withModifiers(($event: any) => (handleNavigation(item.href)), ["prevent"]),
                    class: _normalizeClass([item.current ? 'bg-brand-primary-600 text-white' : 'text-white hover:bg-brand-primary-500 hover:bg-opacity-75', 'rounded-md px-3 py-2 text-sm font-medium cursor-pointer']),
                    "aria-current": item.current ? 'page' : undefined
                  }, _toDisplayString(item.name), 11, _hoisted_7))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (!_unref(isAuthenticated))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleNavigation('login')), ["prevent"])),
                      class: _normalizeClass(['text-white hover:bg-brand-primary-500 hover:bg-opacity-75', 'rounded-md px-3 py-2 text-sm font-medium cursor-pointer'])
                    }, " Sign In "))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_unref(isAuthenticated))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", _hoisted_13, [
                    _hoisted_14,
                    _hoisted_15,
                    _createVNode(_unref(BellIcon), {
                      class: "h-6 w-6",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createVNode(UserMenuItem)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_unref(DisclosureButton), { class: "relative inline-flex items-center justify-center rounded-md bg-brand-primary-600 p-2 text-brand-primary-200 hover:bg-brand-primary-500 hover:bg-opacity-75 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-primary-600" }, {
              default: _withCtx(() => [
                _hoisted_17,
                _hoisted_18,
                (!open)
                  ? (_openBlock(), _createBlock(_unref(Bars3Icon), {
                      key: 0,
                      class: "block h-6 w-6",
                      "aria-hidden": "true"
                    }))
                  : (_openBlock(), _createBlock(_unref(XMarkIcon), {
                      key: 1,
                      class: "block h-6 w-6",
                      "aria-hidden": "true"
                    }))
              ]),
              _: 2
            }, 1024)
          ])
        ])
      ]),
      _createVNode(_unref(DisclosurePanel), {
        class: "md:hidden",
        role: "mobile-nav"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
              return (_openBlock(), _createBlock(_unref(DisclosureButton), {
                key: item.name,
                as: "a",
                onClick: _withModifiers(($event: any) => (handleNavigation(item.href)), ["prevent"]),
                class: _normalizeClass( [item.current ? 'bg-brand-primary-700 text-white'
					: 'text-white hover:bg-brand-primary-500 hover:bg-opacity-75'
					, 'block rounded-md px-3 py-2 text-base font-medium cursor-pointer' ]),
                "aria-current": item.current ? 'page' : undefined
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "class", "aria-current"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_ctx.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("img", {
                      class: "h-10 w-10 rounded-full",
                      src: _ctx.user.imageUrl,
                      alt: ""
                    }, null, 8, _hoisted_23)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.user.name), 1),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.user.email), 1)
                  ]),
                  _createElementVNode("button", _hoisted_27, [
                    _hoisted_28,
                    _hoisted_29,
                    _createVNode(_unref(BellIcon), {
                      class: "h-6 w-6",
                      "aria-hidden": "true"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNavigation, (item) => {
                return (_openBlock(), _createBlock(_unref(DisclosureButton), {
                  key: item.name,
                  as: "a",
                  onClick: _withModifiers(($event: any) => (handleNavigation(item.href)), ["prevent"]),
                  class: "block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-brand-primary-500 hover:bg-opacity-75"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})